const DO_NOT_EXIST = -1
const FUNCTION_LENGTH = 8
const START_STRING = 0
const MAX_FUNCTION_LENGTH = 200
const MAX_STRING_LENGTH = 10_000

function truncate(str: string, max: number): string {
  if (str.length <= max) return str
  return str.substring(0, max) + '...[truncated]'
}

export function stringify(obj: object) {
  const cache: Array<object> = []
  const str = JSON.stringify(obj, function (key, value) {
    if (typeof value === 'object' && value !== null) {
      // Skip DOM nodes entirely
      if (typeof Node !== 'undefined' && value instanceof Node) {
        return '[DOM Node]'
      }

      if (cache.indexOf(value) !== DO_NOT_EXIST) {
        // Circular reference found, discard key
        return
      }
      // Store value in our collection
      cache.push(value)
    }
    // https://github.com/vkiryukhin/jsonfn/blob/master/jsonfn.js#L36
    let fnBody

    if (value instanceof Function || typeof value === 'function') {
      fnBody = value.toString()

      if (
        fnBody.length < FUNCTION_LENGTH ||
        fnBody.substring(START_STRING, FUNCTION_LENGTH) !== 'function'
      ) {
        //this is ES6 Arrow Function
        return truncate('_arrow_' + fnBody, MAX_FUNCTION_LENGTH)
      }
      return truncate(fnBody, MAX_FUNCTION_LENGTH)
    }

    if (value instanceof RegExp) {
      return '_regexp_' + value
    }

    if (typeof value === 'string' && value.length > MAX_STRING_LENGTH) {
      return truncate(value, MAX_STRING_LENGTH)
    }

    return value
  })

  return str
}
